import { TypeOrNull } from 'models/Common'

export const removeTrailingBlankSpace = (text: string) => {
  const regex = new RegExp('<p><br></p>$')
  if (regex.test(text)) {
    return text.substring(0, text.length - 11)
  } else {
    return text
  }
}

/**
 * Remove trailing blank space from rich text fields
 * @param values - The values to remove trailing blank space from
 * @param richTextFieldNames - The names of the rich text fields to remove trailing blank space from
 * @returns The values with trailing blank space removed from the rich text fields
 */
export const mapFormWithQuill = (values: any, richTextFieldNames: string[]) => {
  const newValues: any = values
  richTextFieldNames.forEach(
    (richTextFieldName) =>
      (newValues[richTextFieldName] = removeTrailingBlankSpace(values[richTextFieldName] as string))
  )
  return newValues
}

export const extractStringFromHTML = (HTML: TypeOrNull<string>) =>
  HTML === null ? '' : HTML.replace(/<(.|\n)*?>/g, '').trim()

/**
 * Helper function that replaces underscore with empty space on input string and converts it to uppercase
 * @param text
 */
export const formatStringToUpperCaseAndRemoveUnderscorePrefix = (text: string) =>
  text.replace(/_/g, ' ').toUpperCase()

/**
 * Helper function that removes whitespaces from text and checks if the string is empty
 * @param text
 */
export const isEmptyString = (text?: string) => !(text?.toString() || '').trim().length

/**
 * Helper function that adds `'s` or `'` at the end of a name, then it returns the edited name
 * @param name
 */
export const nameWithApostropheS = (name: string) => {
  if (name.charAt(name.length - 1) === 's') return `${name}'`
  return `${name}'s`
}
